var EventEmitter = require("enyo-ui/EventEmitter"),
    kind         = require("enyo/kind"),
    utils        = require("enyo/utils");

require("enyo-ui");

/**
 * [EventEmitterSupport]{@link enyo-ui.EventEmitterSupport} allows registering
 * event listeners, while avoiding enyo.EventEmitter's unfortunate destructive
 * replacing of the kind's `silence` and `unsilence` methods.
 *
 * @mixin enyo-ui.EventEmitterSupport
 * @public
 */
module.exports = {

    /**
     * @private
     */
    name: "enyo-ui.EventEmitterSupport",

    /**
     * The EventEmitter instance will live here.
     *
     * @type     {enyo-ui.EventEmitter}
     * @memberof enyo-ui.EventEmitterSupport
     * @public
     */
    eventEmitter: null,

    /**
     * Init EventEmitter instance.
     *
     * @memberof enyo-ui.EventEmitterSupport
     * @method
     * @private
     */
    initComponents: kind.inherit(function(sup) {
        return function() {
            this.eventEmitter = new EventEmitter();
            sup.apply(this, arguments);
        };
    }),

    /**
     * Adds an event listener. Until
     * [removed]{@link enyo.ui.EventEmitterSupport#off}, this listener will fire
     * every time the event is
     * [emitted]{@link enyo.ui.EventEmitterSupport#emit}.
     *
     * @param   {String}    event     The event name.
     * @param   {Function}  listener  The listener function.
     * @param   {Object=}   context   The optional context under which to
     *                                execute the listener.
     * @memberof enyo-ui.EventEmitterSupport
     * @method
     * @public
     */
    on: function(event, listener, context) {
        context = context || this;
        this.eventEmitter.on(event, listener, context);
    },

    /**
     * Removes an event listener.
     *
     * @param   {String}    event     The event name.
     * @param   {Function}  listener  The listener function.
     * @param   {Object=}   context   The optional context, if supplied when
     *                                added, it should be added when removing
     *                                the listener as well.
     * @memberof enyo-ui.EventEmitterSupport
     * @method
     * @public
     */
    off: function(event, listener, context) {
        context = context || this;
        this.eventEmitter.off(event, listener, context);
    },

    /**
     * Executes all listeners registered for the supplied event.
     *
     * Listeners will be called with the following arguments:
     *  - This instance as sender,
     *  - The event name
     *  - The supplied other arguments
     *
     * Listeners will not be executed if either the kind instance or the emitter
     * are silenced.
     *
     * The [emitter]{@link eny-ui.EventEmitterSupport#eventEmitter} has
     * silence/unsilence methods of it's own which are completely decoupled from
     * the host kind. Use these if you only want to silence the emitter, rather
     * than the entire kind instance.
     *
     * @param    {String}   event  The event to emit.
     * @param    {...Array} args   All subsequent arguments will be passed to
     *                            the event listeners.
     * @returns  {Boolean}  Whether or not any listeners were notified.
     * @memberof enyo-ui.EventEmitterSupport
     * @method
     * @public
     */
    emit: function(event) {
        var emitter = this.eventEmitter,
            listeners,
            args,
            i,
            n,
            listener;

        if (this._silenced || emitter._silenced) {
            return false;
        }

        listeners = emitter.listeners(event);

        if (listeners.length) {
            for (i = 0, n = listeners.length; i < n; i++) {
                listener = listeners[i];
                args     = utils.toArray(arguments);
                args.unshift(this);
                listener.method.apply(listener.ctx, args);
            }

            return true;
        }

        return false;
    },

    /**
     * Destroy EventEmitter instance.
     *
     * @memberof enyo-ui.EventEmitterSupport
     * @method
     * @private
     */
    destroy: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);
            this.eventEmitter.destroy();
        };
    })

};
